const styles = {
  rootRow: {
    pt: { xs: 2, md: 2 },
    px: { xs: 2, md: 0 },
    backgroundColor: 'background.primary',
    width: '100%',
  },
  rootColumn: {
    marginTop: 2,
    backgroundColor: 'background.grey',
  },
  title: {
    marginBottom: 2,
  },

  subtitle: {
    marginBottom: 4,
  },

  buttonGrid: {
    '& .MuiButton-root': {
      whiteSpace: 'nowrap',
    },
  },
}

export default styles
